import { render, staticRenderFns } from "./rankingBoard.vue?vue&type=template&id=aa8fdbca&"
import script from "./rankingBoard.vue?vue&type=script&lang=ts&"
export * from "./rankingBoard.vue?vue&type=script&lang=ts&"
import style0 from "./rankingBoard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports